import producer from 'immer';
import { START_PHOTO_SESSION } from 'containers/Checklist/types';
import {
  FETCH_ENTRY_ACCESS,
  FETCH_PHOTO_SESSION_DETAIL,
  FETCH_LISTING_REPRESENTATIVE,
} from './types';
import {
  addPhotoSessionDetailToState,
  handleEntryAccess,
  handleListingRepresentative,
  startPhotoSessionInStore,
} from './handlers';

export const initialState = {
  id: undefined,
  dueDate: new Date(),
  fixed: false,
  notes: '',
  status: '',
  owner: {
    id: 0,
    name: '',
    phoneNumber: '',
  },
  house: {
    id: 0,
    address: '',
    complement: '',
    neighborhood: '',
    street: '',
    number: 0,
    city: '',
    stateName: '',
    type: '',
    lat: 0,
    lng: 0,
    shortId: 0,
    areaTotal: 0,
    numeroVagas: 0,
  },
  condoName: undefined,
  entryAccessData: null,
  listingRepresentative: null,
  listingRepresentativeLoaded: false,
};

export const photoSessionDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PHOTO_SESSION_DETAIL:
      return addPhotoSessionDetailToState(state, action);
    case START_PHOTO_SESSION:
      return startPhotoSessionInStore(state, action);
    case FETCH_ENTRY_ACCESS:
      return handleEntryAccess(state, action);
    case FETCH_LISTING_REPRESENTATIVE:
      return handleListingRepresentative(state, action);
    default:
      return state;
  }
};

export default producer(photoSessionDetailReducer);
